// All values are intentionally empty/placeholder — they must come from Docker
// environment variables at runtime via EnvironmentService (environment-loader.ts).
// EnvironmentService validates every field and refuses to start if any is missing.
//
// Staging must behave identically to production for real pre-prod testing —
// dev-Firebase fallback is the bug, not the feature. Until a separate staging
// Firebase project exists, staging deploys will fail; see fix/TASKS.md.
export const environment = {
  production: false,
  hmr: false,
  buildVersion: 'stg-' + Date.now(),
  apiUrl: 'https://stg-api.peopleflow.sk/',
  openApiUrl: 'https://stg-api.peopleflow.sk/openapi/',
  dashboardUrl: 'https://stg-app.peopleflow.sk/',
  googleMapsApiKey: '',
  firebase: {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
  },
  legal: {
    termsOfUseUrl: 'https://staging.peopleflow.sk/terms-of-use',
    privacyPolicyUrl: 'https://staging.peopleflow.sk/privacy-policy',
  },
};
